import SearchBarDateRangeInput from '@components/ui/search/SearchBarInput/SearchBarDateInput/SearchBarRangeDatePickerInput/SearchBarDateRangePickerInput';
import SearchBarSingleDatePickerInput from '@components/ui/search/SearchBarInput/SearchBarDateInput/SearchBarSingleDatePickerInput/SearchBarSingleDatePickerInput';
import { DayPickerRangeControllerProps } from '@components/DatePicker/DateRangePicker/DateRangePicker';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { SearchBarInputError } from '@components/views/flight/types';
import { DayPickerSingleDateControllerProps } from '@components/DatePicker/SingleDatePicker/SingleDatePicker';

import { isFlightReturnDateOutsideRange } from './utils';

export interface SearchBarRangeDatePickerProps
  extends Pick<
    DayPickerRangeControllerProps,
    'startDate' | 'endDate' | 'onDatesChange' | 'minimumNights'
  > {
  error?: SearchBarInputError | boolean;
  inputComponent:
    | 'shopAndFlyHomePageFlight'
    | 'shopAndFlyHomePageHotel'
    | 'setur';
}

const SearchBarRangeDatePicker = ({
  startDate,
  endDate,
  onDatesChange,
  minimumNights,
  error,
  inputComponent,
}: SearchBarRangeDatePickerProps) => (
  <LocationAnimationErrorBox hasError={!!error}>
    <SearchBarDateRangeInput
      dateProps={{
        minimumNights,
        startDate,
        endDate,
        onDatesChange,
        isOutsideRange: (day) => isFlightReturnDateOutsideRange(day, startDate),
      }}
      placeholder='Gidiş - Dönüş Tarihleri'
      label='Gidiş-Dönüş Tarihiniz?'
      inputComponent={inputComponent}
    />
  </LocationAnimationErrorBox>
);

export interface SearchBarSingleDatePickerProps
  extends Pick<DayPickerSingleDateControllerProps, 'date' | 'onDateChange'> {
  error?: SearchBarInputError | boolean;
  inputComponent:
    | 'shopAndFlyHomePageFlight'
    | 'shopAndFlyHomePageHotel'
    | 'setur';
}

const SearchBarSingleDatePicker = ({
  date,
  onDateChange,
  error,
  inputComponent,
}: SearchBarSingleDatePickerProps) => (
  <SearchBarSingleDatePickerInput
    placeholder='Gidiş Tarihi'
    label='Gidiş Tarihiniz?'
    error={Boolean(error)}
    dateProps={{
      date,
      onDateChange,
    }}
    inputComponent={inputComponent}
  />
);

export { SearchBarRangeDatePicker, SearchBarSingleDatePicker };
